import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) return setError("La nuova password deve avere almeno 8 caratteri");
    if (pw !== pw2) return setError("Le due password non coincidono");
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-dark min-h-screen flex items-center justify-center p-4 relative overflow-hidden" data-testid="reset-password-page">
      <div className="absolute -top-40 -right-40 h-96 w-96 rounded-full bg-[#10B981]/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-[#1E4FD8]/15 blur-3xl" />
      <div className="relative w-full max-w-md animate-fade-up">
        <div className="flex flex-col items-center mb-8">
          <img src="/logo.png" alt="Nouvelle WhatsApp" className="h-28 w-28 mb-2 rounded-3xl bg-[#0F172A] p-3 shadow-lg" />
          <p className="text-slate-400 text-sm tracking-wide">Scegli una nuova password</p>
        </div>
        <form onSubmit={submit} className="bg-[#111827]/80 backdrop-blur-md border border-[#1F2937] rounded-2xl p-8 space-y-5 shadow-2xl">
          {!token ? (
            <p className="text-sm text-[#EF4444]" data-testid="reset-missing-token">Link non valido. <Link to="/login" className="underline">Torna al login</Link> e richiedi un nuovo link.</p>
          ) : done ? (
            <div className="text-center space-y-2" data-testid="reset-success">
              <CheckCircle2 className="h-10 w-10 text-[#10B981] mx-auto" />
              <p className="text-slate-100 font-medium">Password aggiornata</p>
              <p className="text-xs text-slate-400">Ti stiamo riportando al login…</p>
            </div>
          ) : (
            <>
              <div className="space-y-2">
                <Label className="text-slate-300">Nuova password</Label>
                <Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} required className="bg-[#0A0E17] border-[#1F2937] text-slate-100 h-11" data-testid="reset-password-new" />
              </div>
              <div className="space-y-2">
                <Label className="text-slate-300">Ripeti nuova password</Label>
                <Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} required className="bg-[#0A0E17] border-[#1F2937] text-slate-100 h-11" data-testid="reset-password-confirm" />
              </div>
              {error && <div className="text-sm text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-lg px-3 py-2" data-testid="reset-error">{error}</div>}
              <Button type="submit" disabled={busy} className="w-full h-11 bg-[#10B981] hover:bg-[#059669] text-[#0A0E17] font-semibold" data-testid="reset-submit-button">
                {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <><KeyRound className="h-4 w-4 mr-2" /> Salva nuova password</>}
              </Button>
              <p className="text-center text-xs text-slate-500"><Link to="/login" className="hover:text-[#10B981]">Torna al login</Link></p>
            </>
          )}
        </form>
      </div>
    </div>
  );
}
